export default "__VITE_ASSET__f79eddb2__"